<div class="modal common-right-modal benefit-modal d-block" [ngClass]="{'show': showSlider}" id="EditRuleConf"
  aria-hidden="true" aria-labelledby="exampleModalToggleLabel" tabindex="-1">
  <div class="modal-dialog modal-half">
    <div class="modal-content">
      <div class="modal-header upload-modal">
        <div class="title-head d-flex align-items-center">
          <button id="btnAddGroupClose" type="button" class="btn-close tool-wrap position-relative"
            data-bs-dismiss="modal" (click)="closePopup()" aria-label="Close">
            <div class="custom-tooltip tooltip-top" role="tooltip">
              <div class="arrow"></div>
              <div class="tooltip-inner"> Close </div>
            </div>
          </button>
          <h2 class="modal-title" id="exampleModalToggleLabel">
            <div class="d-flex align-items-center">
              {{isAddPage?"Add Rule Configurations":"Edit Rule Configurations"}}
            </div>
          </h2>
        </div>
        <div class="btn-wrap">
          <button type="button" class="btn btn-outline-secondary" id="Upload-cancel-btn"
            (click)="closePopup()">Cancel</button>
          <button type="button" class="btn btn-primary" id="upload-save-btn"
            (click)="isAddPage?saveConfig():updateConfig()">
            Save
          </button>
        </div>
      </div>
      <div class="inner-loader-wraper" *ngIf="isLoader">
        <div class="inner-loader"></div>
      </div>
      <ng-container *ngIf="!isLoader">
        <div class="modal-body insurance-modal" [formGroup]="addConfigForm">
          <div class="row">
            <ng-container *ngIf="user?.userType == 1 && !systemConfigEdit">
              <div class="col-4 mb-3">
                <div class="form-group">
                  <label for="radio-button" style="white-space:nowrap" class="form-label">Subscriber type<span
                      class="mandatory">*</span></label>
                  <div class="radio-list  form-check-wrap">
                    <div class="form-check form-check-inline"
                      *ngIf="checkPermission('getProvider')  && ( subTypeEvm == subTypes.provider|| subTypeEvm == subTypes.both)">
                      <input class="form-check-input" type="radio" id="radio-buttonProvider-add" appPreventFirstSpace
                        (change)="setSubscriberType($event)" name="radio-button1" formControlName="subType"
                        value="provider">
                      <label class="form-check-label" for="radio-buttonProvider-add"> Provider</label>
                    </div>
                    <div class="form-check form-check-inline"
                      *ngIf="checkPermission('getPayer')  && ( subTypeEvm == subTypes.payer|| subTypeEvm == subTypes.both)">
                      <input class="form-check-input" type="radio" id="radio-buttonPayer-add"
                        (change)="setSubscriberType($event)" name="radio-button1" formControlName="subType"
                        value="payer">
                      <label class="form-check-label" for="radio-buttonPayer-add"> Payer</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-4 mb-3">
                <label for="LinkedProvider" class="form-label">{{setDropDownPlaceHolder()}}<span
                    class="mandatory">*</span></label>
                <div *ngIf="addConfigForm?.controls?.['subType']?.value == 'provider'"
                  [ngClass]="{'is-invalid' : submitted && addConfigForm?.controls?.['subscriberId']?.errors?.['required']}"
                  tabindex="0" class="ngx-dropdown-container">
                  <app-select-dropdown id="providerId" [options]="providerList" label="providerName"
                    [placeholder]="'Select'" formControlName="subscriberId">
                  </app-select-dropdown>
                </div>
                <div *ngIf="addConfigForm?.controls?.['subType']?.value == 'payer'"
                  [ngClass]="{'is-invalid' : submitted && addConfigForm?.controls?.['subscriberId']?.errors?.['required']}"
                  tabindex="0" class="ngx-dropdown-container">
                  <app-select-dropdown id="payerId" [options]="payerList" label="payerName" [placeholder]="'Select'"
                    formControlName="subscriberId">
                  </app-select-dropdown>
                </div>
                <span *ngIf="submitted && addConfigForm?.controls?.['subscriberId']?.errors?.['required']"
                  class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
              </div>
            </ng-container>
            <div class="col-4 mb-3">
              <label for="RCVersion" class="form-label">Version<span class="mandatory">*</span></label>
              <input [ngClass]="{'is-invalid': submitted && addConfigForm?.controls?.['version']?.errors?.['required']}"
                type="text" class="form-control" id="RCVersion" formControlName="version" placeholder=""
                appPreventFirstSpace>
              <span *ngIf="submitted && addConfigForm?.controls?.['version']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
            </div>
            <div class="col-4 mb-3">
              <div class="info-wrap-input">
                <a class="info-sm-icon tool-wrap">
                  <div class="custom-tooltip tooltip-bottom" style="top:20px; bottom: auto;" role="tooltip">
                    <div class="arrow"></div>
                    <div class="tooltip-inner">{{infoMsg.limit_Dispense}}</div>
                  </div>
                </a>
                <label for="RCDispense" class="form-label">Limit Dispense (Days)<span class="mandatory">*</span></label>
                <input appPreventFirstSpace
                  [ngClass]="{'is-invalid': submitted && addConfigForm?.controls?.['dispenseLimit']?.errors?.['required']}"
                  type="text" class="form-control" id="RCDispense" placeholder="" formControlName="dispenseLimit">
              </div>
              <span *ngIf="submitted && addConfigForm?.controls?.['dispenseLimit']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
            </div>
            <div class="col-4 mb-3">
              <div class="form-group">
                <label for="radio-button" style="white-space:nowrap" class="form-label">Calculate Best Package Size
                  Based On<span class="mandatory">*</span></label>
                <div class="radio-list  form-check-wrap">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="radio-buttonPrice" name="radio-button"
                      formControlName="packSize" value="LOWCOST" appPreventFirstSpace>
                    <label class="form-check-label" for="radio-buttonPrice">Low Cost</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="radio-buttonWastage" name="radio-button"
                      formControlName="packSize" value="LEASTWASTAGE" appPreventFirstSpace>
                    <label class="form-check-label" for="radio-buttonWastage">Least Wastage</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mb-3">
              <div class="info-wrap-input">
                <a class="info-sm-icon tool-wrap">
                  <div class="custom-tooltip tooltip-top" role="tooltip">
                    <div class="arrow"></div>
                    <div class="tooltip-inner">{{infoMsg.refill_Cut_Off}}</div>
                  </div>
                </a>
                <label for="RCcutoff" class="form-label">Refill Cut Off<span class="mandatory">*</span></label>
                <input type="text" id="RCcutoff" class="form-control" formControlName="refill" appPreventFirstSpace
                  [ngClass]="{'is-invalid': submitted && addConfigForm?.controls?.['refill']?.errors?.['required']}">
              </div>
              <span *ngIf="submitted && addConfigForm?.controls?.['refill']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
            </div>
            <div class="col-4 mb-3">
              <div class="info-wrap-input">
                <a class="info-sm-icon tool-wrap">
                  <div class="custom-tooltip tooltip-top" role="tooltip">
                    <div class="arrow"></div>
                    <div class="tooltip-inner">{{infoMsg.max_Refill}}</div>
                  </div>
                </a>
                <label for="maxDDays" class="form-label">Max Refill<span class="mandatory">*</span></label>
                <input type="text" id="maxDDays" class="form-control" formControlName="maxDuration" appPreventFirstSpace
                  [ngClass]="{'is-invalid': submitted && addConfigForm?.controls?.['maxDuration']?.errors?.['required']}">
              </div>
              <span *ngIf="submitted && addConfigForm?.controls?.['maxDuration']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
            </div>

            <!-- Drug in hand -->
            <div class="col-4 mb-3">
              <div class="form-group">
                <label for="radio-button" style="white-space:nowrap" class="form-label">Drug In Hand Selection<span
                    class="mandatory">*</span></label>
                <div class="radio-list  form-check-wrap">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="considerDrugInHand-enabled"
                      formControlName="considerDrugInHand" value="ENABLED" appPreventFirstSpace>
                    <label class="form-check-label" for="considerDrugInHand-enabled">Enabled</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="considerDrugInHand-disabled"
                      formControlName="considerDrugInHand" value="DISABLED" appPreventFirstSpace>
                    <label class="form-check-label" for="considerDrugInHand-disabled">Disabled</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-4 mb-3">
              <div class="form-group">
                <label for="radio-button" style="white-space:nowrap" class="form-label">Dispense Type<span
                    class="mandatory">*</span></label>
                <div class="radio-list  form-check-wrap">
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="dispenseType-strip"
                      formControlName="dispenseType" value="STRIP/PACKET" appPreventFirstSpace>
                    <label class="form-check-label" for="dispenseType-strip">Strip/Packet</label>
                  </div>
                  <div class="form-check form-check-inline">
                    <input class="form-check-input" type="radio" id="dispenseType-partial"
                      formControlName="dispenseType" value="PARTIAL" appPreventFirstSpace>
                    <label class="form-check-label" for="dispenseType-partial">Partial</label>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <label for="MasterdrugListValidityAdd" class="form-label">Validity
                  Start<span class="mandatory">*</span></label>
                <app-datepicker_v2 formControlName="validityStart" [field]="validity_date_v2" [disabled]="!isAddPage"
                  [isInValid]="(submitted && addConfigForm?.controls?.['validityStart']?.errors?.['required']) || addConfigForm?.controls?.['validityStart']?.errors?.['patternCheck'] ||
                            (addConfigForm?.controls?.['validityStart']?.errors?.['checkDateWithToday'] && isAddPage) || addConfigForm?.controls?.['validityStart']?.errors?.['checkStartDate'] ||
                            (startError && isAddPage)">
                </app-datepicker_v2>
              </div>
              <span *ngIf="submitted && addConfigForm?.controls?.['validityStart']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
              <span *ngIf="addConfigForm?.controls?.['validityStart']?.errors?.['patternCheck']"
                class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
              <span *ngIf="addConfigForm?.controls?.['validityStart']?.errors?.['checkDateWithToday'] && isAddPage"
                class="invalid-feedback d-block" tabindex="0">Start date must be greater than or equal to
                today</span>

              <span *ngIf="addConfigForm?.controls?.['validityStart']?.errors?.['checkStartDate']"
                class="invalid-feedback d-block" tabindex="0">{{startDateError}}</span>
              <span *ngIf="startError && isAddPage" class="invalid-feedback d-block"
                tabindex="0">{{startDateError}}</span>
            </div>
            <div class="col-4 mb-3">
              <div class="form-group">
                <label for="MasterdrugListValidityAdd" class="form-label">Validity
                  End<span class="mandatory">*</span></label>
                <app-datepicker_v2 formControlName="validityEnd" [field]="validity_date_v2" [disabled]="isAddPage"
                  (focusout)="checkEndDate()" [isInValid]="(submitted && addConfigForm?.controls?.['validityEnd']?.errors?.['required']) ||
                addConfigForm?.controls?.['validityEnd']?.errors?.['patternCheck'] || addConfigForm?.controls?.['validityEnd']?.errors?.['checkDateWithToday'] ||
                (startError && !isAddPage)">
                </app-datepicker_v2>

              </div>
              <span *ngIf="submitted && addConfigForm?.controls?.['validityEnd']?.errors?.['required']"
                class="invalid-feedback d-block" tabindex="0">{{requiredMsgError}}</span>
              <span *ngIf="addConfigForm?.controls?.['validityEnd']?.errors?.['patternCheck']"
                class="invalid-feedback d-block" tabindex="0">{{validationMsg}}</span>
              <span *ngIf="addConfigForm?.controls?.['validityEnd']?.errors?.['checkDateWithToday'] "
                class="invalid-feedback d-block" tabindex="0">End Date Must be greater than
                or equal to today</span>
              <span *ngIf="startError && !isAddPage" class="invalid-feedback d-block"
                tabindex="0">{{startDateError}}</span>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="rd-head mt-3">
                <h4><img src="assets/images/icons/drug-in-hand.svg" alt="drug icon"> Drug in Hand Expiry</h4>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="benefit-map-table mt-4">
                <div class=" table-container">
                  <table class="table table-borderless table-bg">
                    <caption class="d-none">Drug in Hand Expiry</caption>
                    <thead>
                      <tr>
                        <th scope="col">Select the form of Drug</th>
                        <th scope="col">Expiry (days)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <ng-container *ngFor="let item of drugInHand">
                        <tr>
                          <td>{{item?.drugInForm}}</td>
                          <td>{{item?.allowedDate}}</td>

                        </tr>
                        <tr class="spacer" *ngIf="drugInHand?.length"></tr>
                      </ng-container>


                    </tbody>
                  </table>
                </div>
                <app-navigation *ngIf="!showNavigation" [listLength]="totalCount" [pageNo]="page_no"
                  (currentPageDetail)="currentPageDetail($event)">
                </app-navigation>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
